import { AppBar, Container, IconButton, makeStyles, Toolbar, useScrollTrigger, Slide, useMediaQuery, Typography } from "@material-ui/core"
import { ExitToAppRounded } from "@material-ui/icons";
import { useContext } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { DocumentContext } from '../../Contexts/DocumentContext';
import sgLogo from "../../Images/sgimg.png";

const NavBar = () => {
    const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down("md"));
    const useStyles = makeStyles(theme => ({
        navButtonsGroup: {
            //marginLeft: 'auto',
            display: 'flex',
            alignItems: 'center',
            width: 220
        },
        navButton: {
            fontWeight: 'bold',
            padding: 5,
            "&:hover": {
                backgroundColor: theme.palette.primary.light,
                cursor: 'pointer'
            }
        },
        logos: {
            margin: '0px auto',
            width: '70%',
            display: 'inline-block'
        },
        barContent: {
            marginLeft: 'auto',
            width: '50%'
        },
        icon: {
            width: 60,
            height: 60
        }
    }));

    function HideOnScroll(props) {
        const { children, window } = props;
        // Note that you normally won't need to set the window ref as useScrollTrigger
        // will default to window.
        // This is only being set here because the demo is in an iframe.
        const trigger = useScrollTrigger({ target: window ? window() : undefined });

        return (
            <Slide appear={false} direction="down" in={!trigger}>
                {children}
            </Slide>
        );
    }

    const history = useHistory();
    const location = useLocation();
    const classes = useStyles();
    const { setDocsDownloaded } = useContext(DocumentContext);

    const logoutPressed = () => {
        localStorage.setItem("token", "");
        setDocsDownloaded([]);
        history.push('/login');
        return;
    };

    return (
        <div className="navBar">
            <HideOnScroll>
                <AppBar color="primary" position='sticky'>
                    <Toolbar>
                        <Container maxWidth={false} style={{ padding: 15 }}>
                            <div style={{ display: 'flex', alignItems: 'flex-end' }}>
                                <div className={classes.navButtonsGroup}>
                                    &nbsp;
                                </div>
                                <div className={classes.logos}>
                                    <a href="https://www.sinclairgore.co.uk">
                                        <img width='100%' style={{ paddingBottom: 10, maxWidth: 362, minWidth: 150 }} src={sgLogo} alt="" /><br />
                                        <img src="https://www.sinclairgore.co.uk/wp-content/uploads/2020/01/strapline2.png" style={{ maxWidth: 362, minWidth: 150 }} width='100%' id="sinclairLogo" alt="Plastic, Reconstructive and Cosmetic Surgeon"></img>
                                    </a>
                                </div>
                                <div className={classes.navButtonsGroup}>
                                    {(location.pathname !== '/' && location.pathname !== '/login') &&
                                        <div className={classes.barContent}>
                                            <div className={classes.navButton} onClick={logoutPressed} >
                                                <IconButton iconStyle={classes.logo}>
                                                    <ExitToAppRounded style={{ color: 'white', fontSize: isSmallScreen? 28 : 40 }} />
                                                </IconButton>
                                                <Typography variant={isSmallScreen? "body2" : 'h6'}>Logout</Typography>
                                            </div>
                                            {/* <Typography className={classes.navButton} variant="h6" onClick={logoutPressed}>
                                            Logout
                                </Typography> */}
                                        </div>}
                                    {/* <div className={classes.barContent}>
                                    <Typography className={classes.navButton} variant="h6" onClick={logoutPressed}>
                                        Something
                                </Typography>
                                </div> */}
                                </div>
                            </div>
                        </Container>
                    </Toolbar>
                </AppBar>
            </HideOnScroll>
        </div>
    );
}

export default NavBar;